import React from 'react';
import Header from '../Header';
import Instructions from '../Instructions';

export const defaultPageWrapper = (WrappedComponent, useMainId = true, instructions = false) => {
  return (props) => (
    <div>
      <p className="visuallyhidden">
        <a href="#header">Skip to Site Navigation</a>
        <a href="#main">Skip to Page Content</a>
      </p>
      <div id="container">
        <Header />
        { instructions && <Instructions /> }
        <div id={useMainId ? 'main' : ''} role="main">
          <div className="container">
            <div className="dashboard dashboard--two_col">
              <WrappedComponent {...props} />
            </div>
          </div>
          <footer></footer>
        </div>
      </div>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/wrappers/defaultPageWrapper.jsx